(function (window, document) {
  "use strict";

  var AuroraMotion = {
    config: {
      animationDuration: 4000,
      emojiCount: 60
    },

    particles: ["*", "+", "x", "o", "#", "@", "%"],

    allowedPaths: [
      "/collections/christmas-hampers",
      "/collections/non-alcoholic-christmas-hampers",
      "/pages/christmas-gift-hampers-australia",
    ],

    randomBetween: function (min, max) {
      return Math.random() * (max - min) + min;
    },

    isEligiblePage: function () {
      return this.allowedPaths.indexOf(window.location.pathname) !== -1;
    },

    createParticle: function () {
      var el = document.createElement("div");
      el.className = "emoji-burst";
      el.innerHTML = this.particles[Math.floor(Math.random() * this.particles.length)];

      el.style.left = Math.random() * 100 + "vw";
      el.style.top = this.randomBetween(40, 60) + "vh";

      el.style.setProperty("--x", this.randomBetween(-200, 200) + "px");
      el.style.setProperty("--y", "-" + this.randomBetween(100, 400) + "px");

      return el;
    },

    start: function () {
      if (!this.isEligiblePage()) return;

      for (var i = 0; i < this.config.emojiCount; i++) {
        var p = this.createParticle();
        document.body.appendChild(p);

        setTimeout(
          (function (el) {
            return function () {
              if (el && el.parentNode) el.parentNode.removeChild(el);
            };
          })(p),
          this.config.animationDuration
        );
      }
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      AuroraMotion.start();
    });
  } else {
    AuroraMotion.start();
  }

  window.AuroraMotion = AuroraMotion;

})(window, document);
